import React, { useEffect, useState } from 'react';
import api from '../api';

const AdminDashboard = () => {
  const [users, setUsers] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Add route in users.js for /users (admin only)
        const { data: userList } = await api.get('/users/users'); // Placeholder – add backend route
        const { data: productList } = await api.get('/products');
        setUsers(userList);
        setProducts(productList);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return <div className="text-center py-10">Loading...</div>;

  return (
    <div className="max-w-5xl mx-auto p-6 bg-white rounded-lg shadow-lg">
      <h1 className="text-3xl font-bold mb-8">Admin Dashboard</h1>
      <h2 className="text-2xl mb-4">Users</h2>
      <ul>{users.map(u => <li key={u._id}>{u.flapid} - {u.role}</li>)}</ul>
      <h2 className="text-2xl mb-4 mt-8">Products</h2>
      <ul>{products.map(p => <li key={p._id}>{p.name} ({p.type})</li>)}</ul>
      {/* Add more features: create admin, manage products */}
    </div>
  );
};

export default AdminDashboard;